module.exports = __webpack_public_path__ + "static/media/c3d-vr-coding.83cb602c.jpg";